import * as React from 'react';
import {connect} from "react-redux";
import {Icon, Popup} from "semantic-ui-react";
import {compose} from "redux";
import {selectModeltypeColors} from '../../../../redux/selectors/index';
import {IReduxState} from '../../../../redux/IReduxState';

interface IMapStateToProps {
    colors: string[];
}

interface IOwnProps {
    readOnly: boolean;
    onChange: (value: any) => void;
    value: string | undefined;
    isDarkMode?: boolean;
    // added so that componentBuilder won't complain
    [key: string]: any;
}

interface ColorDropdownProps extends IOwnProps, IMapStateToProps {

}

interface ColorDropdownState {
    isOpen: boolean;
}

class ColorDropdown extends React.Component<ColorDropdownProps, ColorDropdownState> {
    constructor(props: ColorDropdownProps) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    private onChange = (event: React.SyntheticEvent, value: string | undefined) => {
        event.stopPropagation();
        this.setState({isOpen: false});
        if (!this.props.readOnly) {
            this.props.onChange(value);
        }
    }

    render() {
        const {
            readOnly,
            value,
            isDarkMode,
            colors
        } = this.props;
        const darkModeClass = isDarkMode ? 'color-dropdown-dark-mode' : 'color-dropdown-light-mode';

        return (
            <Popup
                content={(
                    <div className='color-dropdown-content'>
                        <div
                            style={{opacity: readOnly ? 0.5 : 1}}
                            className='color-dropdown-no-color color-dropdown-color-box'
                            onClick={(e) => this.onChange(e, undefined)}
                        />
                        {
                            colors.map(color =>
                                <div
                                    className='color-dropdown-color-box'
                                    key={color}
                                    style={{
                                        background: color,
                                        opacity: readOnly ? 0.5 : 1,
                                    }}
                                    onClick={(e) => this.onChange(e, color)}
                                />
                            )
                        }
                    </div>
                )}
                trigger={
                    <div
                        className={`color-dropdown ${darkModeClass}`}
                        style={{opacity: readOnly ? 0.5 : 1}}
                        onClick={() => this.setState({isOpen: true})}
                    >
                        <div
                            className='color-dropdown-selected'
                            style={{background: value ? value : "unset"}}
                        />
                        {value && !readOnly &&
                            <Icon
                                className='color-dropdown-clear'
                                name='close'
                                size='large'
                                onClick={(e: React.SyntheticEvent) => this.onChange(e, undefined)}
                            />
                        }
                    </div>
                }
                className={darkModeClass}
                style={{zIndex: 999999}}
                onClose={() => this.setState({isOpen: false})}
                on='click'
                open={this.state.isOpen}
                position='top left'
                hideOnScroll={true}
            />);
    }
}

const mapStateToProps = (state: IReduxState) => ({
    colors: selectModeltypeColors(state)
});

export default compose<React.ComponentType<IOwnProps>>(
    connect<IMapStateToProps>(mapStateToProps)
)(ColorDropdown);



// WEBPACK FOOTER //
// ./src/components/Table/components/dropdowns/ColorDropdown.tsx